export default __webpack_public_path__ + "static/media/RifleMK1.256.4f3ed76f.png";